<template>
    <div class="card-container">
        <div class="block border-round mb-3">
            <div class="flex flex-column card-container green-container shadow-4">
                <img id="imagemFinal">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormularioFinal',
    
    props: ["ns"],
}
</script>

<style scoped>
    #imagemFinal {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        min-width: 100%;
        min-height: 100%;
        background-size: 100vw 100vh;
        background-image: url("@/assets/imgs/imagem_final_desktop.png");
    }
    @media only screen and (max-width: 920px) {
        @media only screen and (orientation: portrait) {
            #imagemFinal {
                background-image: url("@/assets/imgs/imagem_final_mobile.png");
            }
        }
    } 
    
</style>